var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"body"},[_c('div',[_c('h3',[_vm._v("\n        Anda tidak memiliki akses pada halaman ini, silakan kontak Admin Anda\n      ")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$router.go(-2)}}},[_vm._v("Kembali ke halaman sebelumnya")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e0c857f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forbidden.vue
// module id = null
// module chunks = 